"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyToClipboard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
const __1 = require("..");
function CopyToClipboard({ toCopy, msg, iconProps = {}, children, containerProps = {}, }) {
    const { hasCopied, onCopy } = (0, react_1.useClipboard)(toCopy);
    return ((0, jsx_runtime_1.jsx)(react_1.Tooltip, Object.assign({ isOpen: hasCopied, label: msg !== null && msg !== void 0 ? msg : "Copied to clipboard" }, { children: typeof children === "function" ? (children({ onCopy })) : ((0, jsx_runtime_1.jsxs)(react_1.Flex, Object.assign({}, containerProps, { children: [children, (0, jsx_runtime_1.jsx)(react_1.Icon, Object.assign({ as: __1.CopyIcon, boxSize: 5, onClick: e => {
                        e.stopPropagation();
                        onCopy();
                    }, cursor: "pointer", "aria-label": "copy to clipboard button" }, iconProps))] }))) })));
}
exports.CopyToClipboard = CopyToClipboard;
